module.exports = __webpack_public_path__ + "img/EARLY_VERIFIED_DEVELOPER.5e9fda02.svg";